module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Eggenwil-a48821d104dc418246b7ba6acde3bb81.svg";